const profiles = document.querySelectorAll(".js-profile__accordion");
const bios = document.querySelectorAll(".js-bio__accordion");
let openBio = null;

function handleProfileClick() {
  
    const dataAttributeProfile = this.getAttribute("data-profile");

    bios.forEach(bio => {
        const bioSelected = bio.querySelector(`.bio[data-bio="${dataAttributeProfile}"]`);

        if (bioSelected) {
            if (openBio && openBio !== bioSelected) {
                openBio.classList.remove('active');
                openBio.style.maxHeight = null;
            }

            setTimeout(() => {
                bioSelected.classList.toggle('active');

                if (bioSelected.classList.contains('active')) {
                    bioSelected.style.maxHeight = bioSelected.scrollHeight + "px";
                } else {
                    bioSelected.style.maxHeight = null;
                }
            }, 400);

            openBio = bioSelected;

        } else {
            bio.classList.remove('active');
            bio.style.maxHeight = null;
        }
    });
}

function handleWindowResize() {
    if (window.innerWidth >= 1024) {
        profiles.forEach(profile => {
            profile.addEventListener("click", handleProfileClick);
        });
    } else {
        profiles.forEach(profile => {
            profile.removeEventListener("click", handleProfileClick);
        });
    }
}

// Initial setup
handleWindowResize();
window.addEventListener('resize', handleWindowResize);

const bioCloseButtons = document.querySelectorAll('.js-bio__close');

bioCloseButtons.forEach(closeButton => {
    closeButton.addEventListener('click', (e) => {
        e.preventDefault();

        const activeBio = document.querySelector('.js-bio__accordion .bio.active');

        if (activeBio) {
            activeBio.classList.remove('active');
            activeBio.style.maxHeight = null;
        }
    });
});
